import { gql } from '@apollo/client';

// Fragment for Plan data
export const PLAN_FRAGMENT = gql`
    fragment PlanFragment on Plan {
        _id
        name
        stripeId
        description
        contact
        highlight
        type
        selected
        theme {
            primaryColor
            secondaryColor
        }
        metadata {
            packages
            description
            footers
            plan
            method
            headers
        }
        prices {
            _id
            stripeId
            unitAmount
            currency
            recurring
            selected
            metadata {
                packages
                description
                footers
                plan
                method
                headers
                type
            }
        }
        features {
            name
            description
            key
        }
    }
`;

// Fragment for PricingTable data
export const PRICING_TABLE_FRAGMENT = gql`
    fragment PricingTableFragment on PricingTable {
        _id
        tableName
        tableDescription
        plans {
            plan {
                ...PlanFragment
            }
            discountId
        }
    }
    ${PLAN_FRAGMENT}
`;

// Query to get all pricing tables
export const GET_ALL_PRICING_TABLES = gql`
    query GetAllPricingTables {
        getAllPricingTables {
            ...PricingTableFragment
        }
    }
    ${PRICING_TABLE_FRAGMENT}
`;

// Query to get pricing table by ID
export const GET_PRICING_TABLE_BY_ID = gql`
    query GetPricingTableById($_id: ID!) {
        getPricingTableById(_id: $_id) {
            ...PricingTableFragment
        }
    }
    ${PRICING_TABLE_FRAGMENT}
`;

// Mutation to create pricing table
export const CREATE_PRICING_TABLE = gql`
    mutation CreatePricingTable($input: PricingTableInput!) {
        createPricingTable(input: $input) {
            ...PricingTableFragment
        }
    }
    ${PRICING_TABLE_FRAGMENT}
`;

// Mutation to update pricing table
export const UPDATE_PRICING_TABLE = gql`
    mutation UpdatePricingTable($_id: ID!, $input: PricingTableInput!) {
        updatePricingTable(_id: $_id, input: $input) {
            ...PricingTableFragment
        }
    }
    ${PRICING_TABLE_FRAGMENT}
`;

// Mutation to delete pricing table
export const DELETE_PRICING_TABLE = gql`
    mutation DeletePricingTable($_id: ID!) {
        deletePricingTable(_id: $_id) {
            _id
            tableName
        }
    }
`;

// Query to get all plans (for selection in forms)
export const GET_ALL_PLANS = gql`
    query getPlans {
        getPlans {
            ...PlanFragment
        }
    }
    ${PLAN_FRAGMENT}
`;
